import { useRouter } from 'next/router'

import { FormattedMessage } from 'react-intl'

import { Estimate } from '@/lib/types'
import { formatCurrency } from '@/lib/utils'

import { HostingTooltip } from '@/components/HostingTooltip'

export const useHostingMessages = ({
  currency,
  monthlyEstimate,
  dailyEstimate
}: {
  currency: string
  monthlyEstimate?: Estimate
  dailyEstimate?: Estimate
}) => {
  const { locale } = useRouter()

  const incomeMessage = (
    <FormattedMessage
      defaultMessage="Доход ~{montlyIncome} в месяц / ~{dailyIncome} в сутки"
      id="device.income.month.day"
      values={{
        montlyIncome: formatCurrency(
          monthlyEstimate?.earnings || 0,
          currency,
          locale
        ),
        dailyIncome: formatCurrency(
          dailyEstimate?.earnings || 0,
          currency,
          locale
        )
      }}
    />
  )

  const hostingMessage = (
    <div className="inline-flex items-center gap-2">
      <FormattedMessage
        defaultMessage="Хостинг {hostingMonth} в месяц / {hostingDay} в сутки"
        id="device.hosting.month.day"
        values={{
          hostingMonth: formatCurrency(
            monthlyEstimate?.expenses || 0,
            currency,
            locale
          ),
          hostingDay: formatCurrency(
            dailyEstimate?.expenses || 0,
            currency,
            locale
          )
        }}
      />
      {currency !== 'RUB' && (
        <HostingTooltip {...{ monthlyEstimate, dailyEstimate }} />
      )}
    </div>
  )

  const getPreorderMessage = (date: string) => (
    <FormattedMessage
      defaultMessage="Устройство начнет зарабатывать {date}"
      id="device.preorder.month.day"
      values={{ date }}
    />
  )

  return { incomeMessage, hostingMessage, getPreorderMessage }
}
